import React from "react";
import { useTranslation } from "react-i18next";
import { KYC_ATTEMPT_STAGES } from "../flow/kycAttemptState";
import { ReviewProgress } from "./ReviewProgress";

const TITLE_KEYS = {
  [KYC_ATTEMPT_STAGES.DOCUMENT]: "kyc.verificationLoading.documentTitle",
  [KYC_ATTEMPT_STAGES.FACE]: "kyc.verificationLoading.faceTitle",
  [KYC_ATTEMPT_STAGES.ADDRESS_PROOF]:
    "kyc.verificationLoading.addressProofTitle",
};

export function VerificationLoadingOverlay({
  stage,
  finalizing = false,
  deviceChecking = false,
}) {
  const { t } = useTranslation();
  const titleKey = deviceChecking
    ? "kyc.verificationLoading.deviceTitle"
    : finalizing
      ? "kyc.verificationLoading.finalTitle"
      : TITLE_KEYS[stage] || TITLE_KEYS[KYC_ATTEMPT_STAGES.DOCUMENT];
  const descriptionKey = deviceChecking
    ? "kyc.verificationLoading.deviceDescription"
    : finalizing
      ? "kyc.verificationLoading.finalDescription"
      : "kyc.verificationLoading.description";

  return (
    <div
      className="absolute inset-0 z-40 flex items-center justify-center bg-white/95 px-6 text-center backdrop-blur-sm"
    >
      <ReviewProgress
        title={t(titleKey)}
        description={t(descriptionKey)}
        titleId="kyc-verification-loading-title"
        progressLabel={
          deviceChecking
            ? t("kyc.verificationLoading.deviceProgress")
            : undefined
        }
        progressText={
          deviceChecking
            ? t("kyc.verificationLoading.deviceProgress")
            : undefined
        }
      />
    </div>
  );
}
